// extracted by mini-css-extract-plugin
module.exports = {"textDesc":"ModalSelectBarcode_textDesc__29Sfr"};